"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentRequestMediaDto = instanceOfDocumentRequestMediaDto;
exports.DocumentRequestMediaDtoFromJSON = DocumentRequestMediaDtoFromJSON;
exports.DocumentRequestMediaDtoFromJSONTyped = DocumentRequestMediaDtoFromJSONTyped;
exports.DocumentRequestMediaDtoToJSON = DocumentRequestMediaDtoToJSON;
exports.DocumentRequestMediaDtoToJSONTyped = DocumentRequestMediaDtoToJSONTyped;
/**
 * Check if a given object implements the DocumentRequestMediaDto interface.
 */
function instanceOfDocumentRequestMediaDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('propertyMediaId' in value) || value['propertyMediaId'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    return true;
}
function DocumentRequestMediaDtoFromJSON(json) {
    return DocumentRequestMediaDtoFromJSONTyped(json, false);
}
function DocumentRequestMediaDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'propertyMediaId': json['propertyMediaId'],
        'fileName': json['fileName'],
    };
}
function DocumentRequestMediaDtoToJSON(json) {
    return DocumentRequestMediaDtoToJSONTyped(json, false);
}
function DocumentRequestMediaDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'propertyMediaId': value['propertyMediaId'],
        'fileName': value['fileName'],
    };
}
